import React, { useState, useEffect, useContext } from 'react';
import { withRouter } from 'react-router';
import { Typography, Spin, Tabs } from 'antd';
import { FileTextOutlined, HomeOutlined } from '@ant-design/icons';
import { ApplicationUIContext } from '@yuhuinc/ui-library';

import styled, { css } from 'styled-components';

import TenantDashboard from './tenant_dashboard/TenantDashboard';
import ApplicationPortal from './application_portal/ApplicationPortal';
import { getContactPortalLead } from './api/contactPortalDetails';

const { Title } = Typography;

const StyledContainer = styled.div`
  overflow: auto;
  padding: ${(props) => (props.isMobile ? `12px` : `20px 350px`)};

  ${(props) =>
    props.isMobile &&
    css`
      height: calc(100% - 55px);
      margin-top: 55px;
      overflow-y: scroll;
      background-color: #fafafa;
    `}
`;

const StyledSpinner = styled(Spin)`
  margin: auto;
  width: 100%;
  margin-top: 42px;
`;

const ContactPortal = ({}) => {
  const { isMobile } = useContext(ApplicationUIContext);

  const [lead, setLead] = useState(null);
  const [portalCotenant, setPortalCotenant] = useState(null);

  useEffect(() => {
    getContactPortalLead().then(({ lead }) => {
      setLead(lead);
      setPortalCotenant(`${lead.cotenants[0]?.id}`);
    });
  }, []);

  function handleTabChange(key) {
    // TODO: call to backend and set portalCotenant
    setPortalCotenant(key);
  }

  function tabTitle(type, title) {
    const tabIcon = type === 'application' ? <FileTextOutlined /> : <HomeOutlined />;
    return (
      <>
        {tabIcon} {title}
      </>
    );
  }

  function tabContent(cotenant) {
    return cotenant.application?.app_type === 'application' ? (
      <ApplicationPortal cotenantId={cotenant.id} />
    ) : (
      <TenantDashboard cotenantId={cotenant.id} />
    );
  }

  return (
    <>
      {!lead ? (
        <StyledContainer className="body" role="main">
          <StyledSpinner />
        </StyledContainer>
      ) : (
        <>
          <StyledContainer
            className="body"
            role={isMobile ? undefined : 'main'}
            isMobile={isMobile}
          >
            <Title level={3}>Welcome, {lead.display_name}!</Title>

            {lead.cotenants.length > 0 && (
              <Tabs activeKey={portalCotenant} onChange={handleTabChange}>
                {lead.cotenants.map((cotenant) => (
                  <Tabs.TabPane
                    tab={tabTitle(cotenant.application?.app_type, cotenant.title)}
                    key={cotenant.id}
                  >
                    {tabContent(cotenant)}
                  </Tabs.TabPane>
                ))}
              </Tabs>
            )}
          </StyledContainer>
        </>
      )}
    </>
  );
};

export default withRouter(ContactPortal);
